
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 5a.746.746 0 00-.53.219L6.44 8.752H3.75a.751.751 0 000 1.5h.125l1.164 6.404a2.252 2.252 0 002.213 1.846h9.496c1.087 0 2.019-.78 2.213-1.846l1.164-6.404h.125a.751.751 0 000-1.5h-2.69l-3.53-3.533a.748.748 0 00-1.06 0 .756.756 0 000 1.066l2.47 2.467H8.56l2.47-2.467a.756.756 0 000-1.066A.746.746 0 0010.5 5zm-5.102 5.252h13.204l-1.116 6.135a.754.754 0 01-.738.615H7.252a.754.754 0 01-.738-.615l-1.116-6.135zm6.602 1.5a.751.751 0 00-.75.75v2.25a.751.751 0 001.5 0v-2.25a.751.751 0 00-.75-.75zm-3.498.008a.75.75 0 00-.617.861l.375 2.25a.75.75 0 101.48-.238l-.375-2.25a.752.752 0 00-.863-.623zm6.996 0a.752.752 0 00-.863.623l-.375 2.25a.75.75 0 101.48.238l.375-2.25a.75.75 0 00-.617-.861z"}})])
          )
        }
      }
    